<template>
  <div class="chart_box">
    <div class="title">{{title}}</div>
    <div class="slider_list">
      <div class="list" v-for="(item, index) in sliderList" :key="index">
        <span>{{item.title}}</span>
        <el-slider class="slider" v-model="params[item.type]" :max="100" :show-tooltip="false"
          @change="handleChangle($event, item.type, item.title)"></el-slider>
        <span class="count">{{params[item.type]}} %</span>
      </div>
    </div>
    <div class="chart" id="chart"></div>
    <div class="button" @click="run" >运行</div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getChartData } from '@/services/exam'
import { postProcessStats } from '@/utils/stats'

export default {
  data() {
    return {
      params: {
        population: 1000000000,
        wear_mask: 0, // 戴口罩率
        hospital_bed: 0, // 床位数 默认50
        lockdown_rate: 0, // 流动数 默认50 值越高表示封锁程度越高，流动性越低
        vaccinated: 0 // 接种疫苗率
      },
      chartBox: undefined,
      option: undefined,
      sliderList: [
        {
          title: '口罩',
          type: 'wear_mask'
        },
        {
          title: '床位',
          type: 'hospital_bed'
        },
        {
          title: '流动',
          type: 'lockdown_rate'
        },
        {
          title: '疫苗',
          type: 'vaccinated'
        }
      ],
      chartData: [
        {
          title: 'total_infections',
          name: '已发病人数',
          x: [],
          y: []
        },
        {
          title: 'hospital_beds_in_use',
          name: '住院数',
          x: [],
          y: []
        },
        {
          title: 'total_deaths',
          name: '已死亡人数',
          x: [],
          y: []
        },
        {
          title: 'IFR',
          name: '死亡率',
          x: [],
          y: []
        }
      ],
      timer: 0
    }
  },
  props: ['title'],
  mounted() {
    this.init()
    this.getChart()
    window.clearInterval(this.timer)
  },
  methods: {
    handleChangle(val, type, title) {
      this.params[type] = val
      postProcessStats({
        event: 'click_chart_' + type,
        note: '点击' + title,
        value: val
      })
    },
    run() {
      this.getChart()
    },
    init() {
      this.chartBox = echarts.init(document.getElementById('chart'))
      this.chartBox.clear()
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let html = '第' + params[0].name + '天 <br>'
            for (let i = 0; i < params.length; i++) {
              html += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>'
              if (params[i].seriesName !== 'series\u0000' + i) {
                if (params[i].seriesName !== '死亡率') {
                  html += params[i].seriesName + ': ' + params[i].value + '人<br>'
                } else {
                  html += params[i].seriesName + ': ' + params[i].value + '%<br>'
                }
              } else {
                if (params[i].seriesName !== '死亡率') {
                  html += params[i].seriesName + ': ' + params[i].value + '人<br>'
                } else {
                  html += params[i].seriesName + ': ' + params[i].value + '%<br>'
                }
              }
            }
            return html
          }
        },
        grid: {
          width: '100%',
          left: '0',
          right: '100',
          containLabel: true
        },
        legend: {
          x: 'center',
          // data: this.currentRate.yAxis.name
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            interval: 18,
            formatter: function (params) {
              var val = ''
              if (params.length > 10) {
                val = params.substr(0, 10) + '...'
                return val
              } else {
                return '第' + params + '天'
              }
            }
          }
        },
        yAxis: [
          {
            name: '百分率：%',
            type: 'value',
            axisLabel: {
              show: true,
              interval: 'auto',
              formatter: '{value}%'
            },
            axisLine: {
              show: false // 不显示坐标轴线
            },
            axisTick: {
              show: false // 不显示坐标轴刻度线
            }
          },
          {
            name: '人数：人',
            type: 'value',
            minInterval: 1,
            axisLabel: {
              show: true,
              interval: 'auto',
              formatter: '{value}人'
            },
            axisLine: {
              show: false // 不显示坐标轴线
            },
            axisTick: {
              show: false // 不显示坐标轴刻度线
            }
          }
        ],
        series: [],
        // title: [
        //   {
        //     subtext: '百分率%'
        //   },
        //   // {
        //   //   subtext: '人数 人',
        //   // }
        // ]
      }
      this.option.color = ['#db6152', '#ffc000', '#c9c9c9', '#637697', '#49464f', '#51d0a3', '#5a9bd5']
      this.$forceUpdate()
      setTimeout(() => {
        window.onresize = this.chartBox.resize
      }, 500)
    },
    getChart() {
      const obj = { ...this.params }
      obj.lockdown_rate = 100 - obj.lockdown_rate
      const chartData = [
        {
          yAxisIndex: 1,
          title: 'new_infections',
          name: '日新增发病人数',
          x: [],
          data: []
        },
        {
          yAxisIndex: 1,
          title: 'total_infections',
          name: '已发病人数',
          x: [],
          data: []
        },
        {
          yAxisIndex: 1,
          title: 'hospital_beds_in_use',
          name: '住院数',
          x: [],
          data: []
        },
        {
          yAxisIndex: 1,
          title: 'total_deaths',
          name: '已死亡人数',
          x: [],
          data: []
        },
        {
          yAxisIndex: 0,
          title: 'IFR',
          name: '死亡率',
          x: [],
          data: []
        }
      ]
      getChartData(obj)
        .then((res) => {
          let keyArr
          const data = []
          res.data.forEach((item, index) => {
            item.date = index + 1
            data.push(item)
            keyArr = Object.keys(item)
          })
          data.forEach(item => {
            chartData.forEach(line => {
              if (keyArr.indexOf(line.title) > -1) {
                line.barWidth = '100'
                line.type = 'line'
                line.smooth = true
                line.animationDuration = 4000
                line.animationEasing = 'cubicInOut'
                line.data.push(item[line.title])
                line.x.push(item.date)
              }
            })
          })
          this.option.series = chartData
          this.option.xAxis.data = chartData[0].x
          this.chartData = [...chartData]
          this.option && this.chartBox.setOption(this.option, true)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.chart_box{
  .title {
    text-indent: 2em;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 28px;
  }
  .slider_list{
    width: 100%;
    display: flex;
    margin-top: 20px;
    // flex-direction: column;
    // height: 400px;
    justify-content: space-between;
    flex-wrap: wrap;
    .list{
      width: 24%;
      position: relative;
      >span{
        font-size: 20px;
        color: #106172;
      }
      .count{
        position: absolute;
        top: -10px;
        right: 10px;
        font-size: 12px;
        border-radius: 5px;
        padding: 2px;
        border: 1px solid #106172;
      }
      /deep/.el-slider.slider{
        width: 70%;
        position: relative;
        top: -30px;
        left: 50px;
        .el-slider__bar {
          background-color: #667c6b;
        }
        .el-slider__button {
          border-color: #667c6b;
        }
      }
      /deep/.el-slider__button-wrapper{
        top: -0.25rem;
      }
    }
  }
  .chart{
    width: 100%;
    height: 400px;
    float: right;
  }
  .button{
    width: 269px;
    height: 44px;
    background: #f8f9ff;
    border-radius: 22px;
    display: flex;
    background: #4D6255;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    line-height: 20px;
    margin: 15px auto;
    cursor: pointer;
  }
}
</style>
